var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');
var PersonsCollection = require('../../collections/persons-collection');

var Radio = require('backbone.radio');
var services = Radio.channel('services');
var notificationsChannel = Radio.channel('notifications');
var utils = new CommonUtils();

var PatientSourcesRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/medicals/patient-sources-row.html'),

    ui: {
        merge: '.merge'
    },

    events: {
        'click @ui.merge': 'onMergeClick'
    },

    templateContext: function () {
        var that = this;
        var createdTime = that.model.get('createdTime');
        return {
            canEdit: that.canEdit,
            fmCreatedTime: createdTime != undefined && createdTime != '' && !isNaN(createdTime)
                ? utils.longToDateTimeFormatted(createdTime, "MM/DD/YYYY hh:mm A") : '-'
        }
    },

    initialize: function (options) {
        var that = this;
        this.canEdit = options.canEdit;
    },

    onRender: function () {

    },

    onMergeClick: function (event) {
        this.triggerMethod('on:merge', {
            selectedId: event.target.id
        });
    }
});


var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(3), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var PatientSourcesTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: PatientSourcesRowView,
    emptyView: EmptyView,

    collectionEvents: {},

    childViewEvents: {
        'on:merge': 'onMerge'
    },

    initialize: function (options) {
        this.collection = options.collection;
        this.canEdit = options.canEdit;
    },

    childViewOptions: function () {
        return {
            canEdit: this.canEdit
        };
    },

    onMerge: function (data) {
        this.triggerMethod('on:merge', data);
    }
});

var PatientSources = Marionette.View.extend({
    template: require('../../templates/medicals/patient-sources.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        }
    },

    ui: {},

    events: {},

    childViewEvents: {
        'on:merge': 'onMerge'
    },

    templateContext: function () {
        var that = this;
        return {
            canEdit: that.canEdit,
            name: that.name
        }
    },


    initialize: function (options) {
        _.bindAll(this, 'onRender', 'showLoading', 'hideLoading', 'logError');
        this.medProfileModel = options.medProfileModel;
        this.name = options.name;
        this.canEdit = options.canEdit;
        var personId = this.medProfileModel.get('object').personId;
        this.personsCollection = new PersonsCollection([], {
            params: [
                {key: 'sortby', value: 'createdTime'},
                {key: 'sortdir', value: 'DESC'},
                {key: 'active', value: 'true'},
                {key: 'active', value: 'false'},
                {key: 'object_mergeableTo', value: personId}
            ]
        });
    },

    onRender: function () {
        var that = this;
        that.showLoading();
        that.personsCollection.fetch({
            success: function () {
                that.showChildView('body', new PatientSourcesTableBody({
                    collection: that.personsCollection,
                    canEdit: that.canEdit
                }));
                that.hideLoading();
            },
            error: function (e) {
                that.logError(e);
            }
        });
    },

    onMerge: function (data) {
        var mergeTo = this.medProfileModel.get('object').personId;
        var mergeFrom = data.selectedId;

        if (_.isEmpty(mergeTo) || _.isEmpty(mergeFrom))
            return;

        Backbone.history.navigate('merge-persons/' + mergeTo + '/' + mergeFrom, {trigger: true});
    },

    showLoading: function () {
        utils.showSpinner();
    },

    hideLoading: function () {
        utils.hideSpinner();
    },

    logError: function (error) {
        utils.hideSpinner();
        notificationsChannel.request('show:notification', JSON.parse(error));
    }

});

module.exports = PatientSources;


//////////////////
// WEBPACK FOOTER
// ./app/views/medicals/patient-sources-view.js
// module id = 372
// module chunks = 0